import { FC } from 'react';

import { BottomSheet, Button } from '@hh.ru/magritte-ui';
import { EllipsisHorizontalOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import { CampaignActionsMenuItem } from 'components/CampaignsDashboard/hooks/useCampaignActionsMenuItems';
import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';

import { CampaignActionsList } from 'components/CampaignsDashboard/components/CampaignsTable/components/CampaignActions/CampaignActionsList';

import { DashboardCampaign } from 'store/models/campaignsDashboard';

import styles from 'components/CampaignsDashboard/components/CampaignsTable/components/CampaignActions/CampaignActionsBottomSheet.module.less';

const TrlKeys = {
    actions: 'CampaignsDashboard.CampaignsTable.CampaignCard.actions',
};

interface CampaignActionsBottomSheetProps {
    campaign: DashboardCampaign;
    isSudo: boolean;
    actionsMenuItems: CampaignActionsMenuItem[];
    sudoActionsMenuItems: CampaignActionsMenuItem[];
}

export const CampaignActionsBottomSheet: FC<CampaignActionsBottomSheetProps> = ({
    campaign,
    isSudo,
    actionsMenuItems,
    sudoActionsMenuItems,
}) => {
    const [visible, setVisibleOn, setVisibleOff] = useOnOffState(false);
    const trls = useTrls();

    return (
        <>
            <Button
                size="small"
                mode="secondary"
                style="neutral"
                icon={<EllipsisHorizontalOutlinedSize16 />}
                hideLabel
                aria-label={trls(TrlKeys.actions)}
                onClick={setVisibleOn}
                data-qa={`campaign-mobile-actions-${campaign.id}`}
            />
            <BottomSheet
                visible={visible}
                onClose={setVisibleOff}
                height="content"
                withContentPaddings={false}
                data-qa={`campaign-actions-bottom-sheet-${campaign.id}`}
            >
                <CampaignActionsList
                    campaignId={campaign.id}
                    actionsMenuItems={actionsMenuItems}
                    sudoActionsMenuItems={sudoActionsMenuItems}
                    isSudo={isSudo}
                    dataQaPrefix="campaign-mobile-action"
                    onAction={setVisibleOff}
                    className={styles.actionsList}
                />
            </BottomSheet>
        </>
    );
};
